// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3L1qw","addWidgetButton":"Header_addWidgetButton__260yK","dashboardTabs":"Header_dashboardTabs__2Hq9d","active":"Header_active__RrAN0"};